var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.attachments),function(item,index){return _c('v-chip',{key:index,staticClass:"ma-1",attrs:{"label":""}},[_vm._v(_vm._s(item.fileName)+" "),_c('v-icon',{staticClass:"mx-2",on:{"click":function($event){return _vm.download(item)}}},[_vm._v("mdi-download")])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }